import { useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Reviews from './components/Reviews';
import Contact from './components/Contact';
import About from './components/About';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import SchemaOrg from '../../components/feature/SchemaOrg';

export default function HomePage() {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px',
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('section');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SchemaOrg />
      <Navigation />
      <Hero />
      <Services />
      <Gallery />
      <Reviews />
      <Contact />
      <About />
      <Footer />
    </div>
  );
}
